import { inject, Injectable } from '@angular/core';
import { SseEventType } from '@api-types/sse/sse.types';
import { SseEventHandler } from '@core/sse/sse-event-handler';
import { CyclesStore } from './cycles.store';

@Injectable()
export class ConsensusCycleInitializationSseHandler implements SseEventHandler<
  typeof SseEventType.ConsensusCycleInitialization
> {
  readonly eventType = SseEventType.ConsensusCycleInitialization;

  private readonly cyclesStore = inject(CyclesStore);

  handle(): void {
    this.cyclesStore.reload();
  }
}
